var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NO_GO",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74.203,
    viewBox: "0 0 74 74.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #NO_GO .cls-1 {\n        fill: #ff7600;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1073.212 -710.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_529",
    "data-name": "Pfad 529",
    className: "cls-1",
    d: "M1110.212,710.482a37.1,37.1,0,1,0,37,37.1A37.051,37.051,0,0,0,1110.212,710.482Zm0,4.639a32.131,32.131,0,0,1,20.324,7.236c.33-.795-35.726,33.776-45.533,45.533a32.449,32.449,0,0,1,25.208-52.769Zm0,64.926a32.131,32.131,0,0,1-20.322-7.236c9.3-9.248,31.589-31.26,45.533-45.531a32.447,32.447,0,0,1-25.211,52.767Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGo);
export default __webpack_public_path__ + "static/media/no-go.0bdc816b66cd80a2f0e21760fb0d3835.svg";
export { ForwardRef as ReactComponent };